module.exports = __webpack_public_path__ + "static/Premium Bandai-a536f5413ab72271b194257a23b6ca56.svg";